import React from 'react';
import PanelMeasure from '@/layout/components/PanelMeasure';
import DatasetsPanelFull from '../containers/DatasetsPanelFull';
import DatasetsPanelNarrow from '../containers/DatasetsPanelNarrow';

const DatasetsPanel = ({ configuration }) => (
  <PanelMeasure
    configuration={configuration}
    component={{ full: DatasetsPanelFull, narrow: DatasetsPanelNarrow }}
    width={560}
  />
);

export default DatasetsPanel;
